export const DESTINATION_REVIEW_TAGS = [
  { value: "BEGINNER_FRIENDLY", label: "Beginner friendly" },
  { value: "FAMILY_FRIENDLY", label: "Family friendly" },
  { value: "FLOWY", label: "Flowy" },
  { value: "TECHNICAL", label: "Technical" },
  { value: "JUMP_FOCUSED", label: "Jump focused" },
  { value: "WELL_MAINTAINED", label: "Well maintained" },
  { value: "ROUGH_TERRAIN", label: "Rough terrain" },
  { value: "SCENIC", label: "Scenic" },
  { value: "CROWDED", label: "Crowded" },
  { value: "GOOD_FACILITIES", label: "Good facilities" },
  { value: "GOOD_VALUE", label: "Good value" },
  { value: "EXPENSIVE", label: "Expensive" },
];

export const REVIEW_TAG_LABELS = Object.fromEntries(
  DESTINATION_REVIEW_TAGS.map(({ value, label }) => [value, label]),
);

export const emptyReviewForm = () => ({ rating: 0, text: "", tags: [] });

export const reviewFormFromExisting = (review) => review ? ({
  rating: review.rating ?? 0,
  text: review.text ?? "",
  tags: [...(review.tags ?? [])],
}) : emptyReviewForm();

export const toggleReviewTag = (tags, tag) => (
  tags.includes(tag) ? tags.filter((value) => value !== tag) : [...tags, tag]
);

export const reviewInputFromForm = (form) => ({
  rating: form.rating,
  text: form.text.trim() || null,
  tags: form.tags,
});

export const communityRatingText = (summary) => {
  if (!summary || !summary.count || summary.average == null) return "No community ratings yet";
  return `${Number(summary.average).toFixed(1)} · ${summary.count} ${summary.count === 1 ? "review" : "reviews"}`;
};

export const destinationReviewReturnTo = (destinationId) =>
  `/park/${encodeURIComponent(destinationId)}?review=write#reviews`;
